<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <div class="col-sm-12">
        <StockInventory />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import StockInventory from '@/components/reports/stockinventory/StockInventory'

export default {
  name: 'TrackersView',
  components: {
    PageTitle,
    PageRowWrapper,
    StockInventory
  }
}
</script>